import Sidenav from './Sidenav';
import Header from "./Header";
import { useState, useEffect } from "react";
import ChangePassword from "../pages/ChangePassword";
import { useAuth } from '../AuthProvider';
import Spinner from '../components/reusable/Spinner';
import { Box } from '@mui/material';

function LayoutWrapper({ children }) {
    const { user } = useAuth();
    const [changePassword, setChangePassword] = useState({ userId: 0, open: false });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const now = new Date();
        const expiry = new Date(user.password_expiry);
        const expired = user.password_expiry?.length > 0 ? now >= expiry : true;
        setChangePassword({ open: false, userId: user.id });
        setLoading(false);
    }, [user.password_expiry, user.id]);



    return (
        <Box sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            padding: 'var(--main-container-padding)',
            gap: '0.875rem',
            background: 'var(--root-background)',
            overflow: 'hidden'
        }}>
            <Sidenav />
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                flexShrink: 1,      
                minWidth: 0,
                height: '100%',

            }}>
                <Header />
                <div className='separator'></div>
                <Box sx={{
                    pr: '1.25rem',
                    pl: '1.25rem',
                    mt: '1.25rem',
                    flex: 1,
                    minHeight: 0,      
                    overflow: 'auto',  
                    display: 'flex',
                    flexDirection: 'column',

                }}>
                    {loading
                        ? <Spinner />
                        : changePassword.open
                            ? <ChangePassword
                                mandatory
                                state={changePassword}
                                setState={setChangePassword} />
                            : children
                    }
                </Box>
            </Box>
        </Box>
    );
}

export default LayoutWrapper;
